export enum DeviceTypes {
  WINDOWS = 1,
  MAC = 2,
  WEB = 3,
  ANDROID = 4,
  IOS = 5,
  LINUX = 6,
  MIGRATION = 7,
  MAC32 = 8,
  MAC64 = 9,
  WIN32 = 10,
  WIN64 = 11,
  WOPI = 12,
  SDK = 13,
  WEBDAV = 14,
}

export const DEVICE_TYPE_LABELS: Partial<Record<DeviceTypes, string>> = {
  [DeviceTypes.WEBDAV]: 'WebDAV',
  [DeviceTypes.SDK]: 'SDK',
};

export function getDeviceTypeLabel(deviceTypeId: number | string | null | undefined): string | undefined {
  return DEVICE_TYPE_LABELS[Number(deviceTypeId) as DeviceTypes];
}
